// jshint strict:false, undef:false, unused:false

/**
	Compatibility Functions
	Stephen Ginn at Crema Design Studio
	Updated 2019-02-07

	Used by these websites:
	- CABA BS3
	- D4E Enrollment Sites
	- MWG Corporate Sites
	- Client Portal
	- Access Portal
	- and probably more...
/*/


(function () {
	// Fix Bootstrap Modal Stacking
	var modals = document.querySelectorAll('.modal');

	for (var i = 0; i < modals.length; i++) {
		document.body.appendChild(modals[i]);
	}

	// Add Modernizr Tests
	var html = document.querySelector('html');

	if (typeof Modernizr !== 'undefined' && Modernizr !== null && Modernizr !== '') {
		Modernizr.addTest("boxsizing", function () {return Modernizr.testAllProps("boxSizing");});
		Modernizr.addTest("webkit-appearance", function () {return Modernizr.testAllProps("webkitAppearance");});
		Modernizr.addTest("moz-appearance", function () {return Modernizr.testAllProps("mozAppearance");});
		Modernizr.addTest('appearance', function () {return Modernizr.testAllProps("appearance");});

		// Detect CSS mask support and hack it into Modernizr
		if (document.body.style[ '-webkit-mask-repeat' ] !== undefined) {
			Modernizr.cssmasks = true;
			html.className += ' cssmasks';
		} else {
			Modernizr.cssmasks = false;
			html.className += ' no-cssmasks';
		}
	}
})();


window.addEventListener("load", function() {
	// PLACEHOLDER FIX FOR IE9
	// This script deletes these elements before the form is submitted. https://gist.github.com/3129271
	// Released under MIT license: http://www.opensource.org/licenses/mit-license.php
	
	var placeholderSupport = ("placeholder" in document.createElement("input"));
	
	if (!placeholderSupport) {
		(function ($) {
			'use strict';
			$(function () {
				$('[placeholder]')
				.focus(function () {
					var input = $(this);
					if (input.val() === input.attr('placeholder')) {
					input.val('').removeClass('placeholder');
				}
				})
				.blur(function () {
					var input = $(this);
					if (input.val() === '' || input.val() === input.attr('placeholder')) {
					input.addClass('placeholder').val(input.attr('placeholder'));
				}
				})
				.blur()
				.parents('form').submit(function () {
					$(this).find('[placeholder]').each(function () {
						var input = $(this);
						if (input.val() === input.attr('placeholder')) {
						input.val('');
						}
					});
				});
			});
		})(jQuery);
	}
	
	// Fix iFrames within Bootstrap Modals
	$('[data-toggle="modal"]').click(function(){
		var $modal = $($(this).attr("href")),
			$iframe = $modal.find("iframe"),
			iframeSrc = $iframe.attr("data-src");

		$modal.on('show.bs.modal', function () {
			$iframe.attr("src",iframeSrc);
		});
	});
});
